export default __webpack_public_path__ + "72ae1b0059c83c435f88d28a26a51257.svg";